import { VnSkyOscLookupImpl } from "../data/VnSkyOscLookupImpl";
import { IVnSkyOscLookupRepository } from "../domain/repositories/IVnSkyOscLookupRepository";
import { VnSkyOscLookupUseCase } from "../domain/useCases/VnSkyOscLookupUseCase";
import { VnskySupportOcsInfoViewModel } from "../presentation/viewModel/VnskySupportOcsInfoViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class VnskySupportOcsInfoInjection extends InjectionModule {
  private static readonly vnSkySupportOcsInfoViewModelToken = Symbol(
    "VnskySupportOcsInfoViewModel",
  );
  private static readonly vnSkyOscLookupRepositoryToken = Symbol(
    "IVnSkyOscLookupRepository",
  );
  private static readonly vnSkyOscLookupUseCaseToken = Symbol(
    "VnSkyOscLookupUseCase",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.vnSkyOscLookupRepositoryToken,
      useClass: VnSkyOscLookupImpl,
    },
    {
      scope: "otherRepo",
      token: this.vnSkyOscLookupUseCaseToken,
      useClass: VnSkyOscLookupUseCase,
    },
    {
      scope: "viewModel",
      token: this.vnSkySupportOcsInfoViewModelToken,
      useClass: VnskySupportOcsInfoViewModel,
    },
  ];

  static getRepo(): IVnSkyOscLookupRepository {
    return this.resolve(this.vnSkyOscLookupRepositoryToken);
  }

  static getUseCase(): VnSkyOscLookupUseCase {
    return this.resolve(this.vnSkyOscLookupUseCaseToken);
  }
}
